module.exports = __webpack_public_path__ + "img/brand_oster.bf89f063.webp";